// import React from 'react';
// import Images from '../../common/images/Images';
// import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap is imported
// import { Link } from 'react-router-dom';
// const Main_Video = () => {
//   return (
//     <div className="position-fixed top-0 start-0 w-100 h-100 overflow-hidden">
//       {/* Fullscreen Video */}
//       <video 
//         className="w-100 h-100 object-fit-cover"
//         autoPlay
//         loop
//         muted
//         playsInline
//       >
//         <source src={Images?.main_video} type="video/mp4" />
//         Your browser does not support the video tag.
//       </video>

//       {/* Overlay Section - Centered Button */}
//       <div className="position-absolute bottom-0 end-0 p-0 translate-middle text-center">
//         <Link to="/hostel_3d_images" className="btn btn-dark btn-lg">
//           Welcome to JECRC
//         </Link>
//       </div>
//     </div>
//   );
// }

// export default Main_Video;


import React, { useRef, useEffect, useState } from "react";
import Images from "../../common/images/Images";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";

const Main_Video = () => {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.volume = isMuted ? 0 : 1;
    }
  }, [isMuted]);

  useEffect(() => {
    localStorage.removeItem("JECRC")
    localStorage.removeItem("Other")
  }, [])
  return (
    <div className="position-fixed top-0 start-0 w-100 h-100 overflow-hidden">
      <video ref={videoRef} className="w-100 h-100 object-fit-cover" autoPlay
        loop
        playsInline
      >
        <source src={Images?.main_video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div
        className="customefooters position-absolute bottom-0 start-50 translate-middle-x mb-5 pb-3 pb-md-0 text-center"
        style={{ zIndex: 10 }}
      >
        <div className="d-md-flex align-items-end gap-3">
          <div onClick={() => {
            localStorage.setItem("JECRC", true)
            localStorage.removeItem("Other")
          }}>
            <Link to="/hostel_3d_images" className="btn btn-dark btn-md-lg w-full fs-6 mt-2 mt-md-0">
              Welcome to JECRC Campus Hostel →
            </Link>
          </div>
          <div onClick={() => {
            localStorage.setItem("Other", true)
            localStorage.removeItem("JECRC")
          }}>
            {/* <Link to="/hostel_booking_room/44" className="btn btn-success btn-md-lg fs-6 mt-3 mt-md-0">
              JECRC Collaborated Hostels →
            </Link> */}

          </div>
          <div onClick={() => {
            localStorage.setItem("Other", true)
            localStorage.removeItem("JECRC")
          }}>
            <Link to="/transport_booking_list" className="btn btn-danger btn-md-lg fs-6 mt-3 mt-md-0">
              Book Transport →
            </Link>

          </div>

        </div>
      </div>

      <button onClick={() => setIsMuted(!isMuted)} className="position-absolute bottom-0 start-0 m-2 btn btn-light">
        {isMuted ? "🔇 Unmute" : "🔊 Mute"}
      </button>

    </div>
  );
};

export default Main_Video;

